import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { applyInitialTheme } from './hooks/useTheme';
import { ManagerApprovalProvider } from './hooks/useManagerApproval';
import { DaySessionProvider } from './hooks/useDaySession';
import { AuthProvider } from './hooks/useAuth';
import './styles.css';

// Apply theme attr before React mounts to avoid a flash of wrong theme.
applyInitialTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ManagerApprovalProvider>
          <DaySessionProvider>
            <App />
          </DaySessionProvider>
        </ManagerApprovalProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Instant-remove the inline CODED preloader (defined in index.html) once
// React has rendered the first frame AND a minimum brand-moment has
// elapsed. We snap-remove rather than fade because fading from the dark
// preloader to the light page background was reading as a "white flash."
const PRELOADER_MIN_MS = 500;
const preloaderStart = performance.now();
requestAnimationFrame(() => {
  const elapsed = performance.now() - preloaderStart;
  const wait = Math.max(0, PRELOADER_MIN_MS - elapsed);
  setTimeout(() => {
    const el = document.getElementById('coded-preloader');
    if (el) el.parentNode?.removeChild(el);
  }, wait);
});
